import {Directive, ElementRef, Host, Input, Optional} from "@angular/core";
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[tipoTexto]',
  host: {
    '(input)': 'this.changeValue($event)',
  }
})

export class TipoTextoDirective {

  @Input('tipoTexto') tipo: string;

  constructor(private ref: ElementRef, @Optional() private control: NgControl) {
  }

  changeValue($event){
    let val = $event.target.value;
    const caretPos = $event.target.selectionStart;

    if(this.tipo == 'upperCase'){
      val = val.toUpperCase();
    }else if(this.tipo == 'lowerCase'){
      val = val.toLowerCase();
    }else if(this.tipo == 'number'){
      val = val.replace(/[^\d]+/g,'');
    }

    this.ref.nativeElement.value = val;

    if (this.control && this.control.control) {
      this.control.control.setValue(val, { emitEvent: false });
    }

    try {
      if ($event.target.setSelectionRange) {
        $event.target.setSelectionRange(caretPos, caretPos);
      }
    } catch (e) {
      // ignorar se o tipo do input não suportar setSelectionRange
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/tipotexto.directive.ts